import React from "react";
import PropTypes from "prop-types";
import "components/Header/Header.css";

//To be shown on top of screens.
function Header(props) {
  const { className: customClassName } = props;
  return (
    <header className={customClassName}>
      <div className="header-left-section">{props.children[0]}</div>
      <div className="header-right-section">{props.children[1]}</div>
    </header>
  );
}

Header.propTypes = {
  children: PropTypes.arrayOf(PropTypes.any),
};

export default Header;
